<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card>
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
            <form-wizard 
                v-else
                title=""
                subtitle=""
                color="#007bff"
                :start-index="activeIndex"
            >
                <template slot="step" slot-scope="props">
                    <wizard-step :tab="props.tab"
                    :transition="props.transition"
                    :key="props.tab.title"
                    :index="props.index">
                    </wizard-step>
                </template>
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                        <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.prev') }} </wizard-button>
                    </div>
                    <div class="wizard-footer-right">
                        <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.next') }} </wizard-button>
                        <wizard-button v-else @click.native="() => onComplete(props.isLastStep)" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? $t('customer.wizzard.complete') : $t('customer.wizzard.next')}}</wizard-button>
                    </div>
                </template>
                <tab-content :title="$t('customer.wizzard.stepName1')" icon="ti-id-badge" class="formGroup" :before-change="() => changeStep(0,1)">
                    <Form ref="GeneralForm" :loading="loading" :customer="{data: $route.params.id }" :forms="GeneralForms" :customField="customField" />
                </tab-content>
                <tab-content :title="$t('customer.wizzard.stepName4')" icon="ti-bag" class="formGroup" :before-change="() => changeStep(1,2)">
                   <Form ref="DealerForm" :loading="loading" :customer="{data: $route.params.id }" :forms="DealerForm" />
                </tab-content>
                <tab-content :title="$t('customer.wizzard.stepName2')" icon="ti-user" class="formGroup"  :before-change="() => changeStep(2,3)"> 
                   <Form ref="UserForm" :loading="loading" :customer="{data: $route.params.id }" :forms="UserForm" />
                </tab-content>
                <tab-content :title="$t('customer.wizzard.stepName3')" icon="ti-star"  :before-change="() => changeStep(3,4)">
                    <Subscribtion :customer="customerStatus"/>
                </tab-content>
                <tab-content :title="$t('customer.wizzard.stepName5')" icon="ti-unlock"  :before-change="() => changeStep(4,5)">
                    <RemoteUser :customer="customerStatus" :modalEvent="openModal" :modalType="pageSettings"/>
                </tab-content>
            </form-wizard>
        </b-card>
    
         <!-- Modals -->
        <DefinationModals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />

    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import _ from 'lodash'
    import Subscribtion from './components/Subscribtion'
    import RemoteUser from './components/RemoteUser'
    import Modals from "./modals/"
    import DefinationModals from "@/pages/General/Defination/modals/"
    import i18n from '@/plugins/i18n';
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'


    let breadCrumb = [
        { label: i18n.t('pages.customer.name'), url: "/Customer/List" },
        { label: i18n.t('pages.customer.addNew'), url: "/Customer/Add" },
    ]
    export default {
        name: 'CustomerAdd',
        data: function(){
            return{
                GeneralForms: Forms.GeneralForms,
                DealerForm: Forms.DealerForm,
                UserForm: Forms.UserForm,
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Customer",
                modalName: "",
                activeIndex: 0,
            }
        },
        created: function(){
            this.$store.dispatch('listFormsCustomFields', 'CST' )
            this.$store.dispatch('company_get', {limit: 100, offset: 0})

        },
        components:{
            BreadCrumb, Form, Subscribtion, Modals, DefinationModals, RemoteUser
        },
        computed: {
            loading(){
                return this.$store.getters.getLoading
            },
            message(){
                return this.$store.getters.getCustomerInfo
            },
            customerData(){
                return this.$store.getters.getCustomerData
            },
            customerStatus(){
                if (typeof(this.$store.getters.getCustomerInfo) ==  'string')
                    return JSON.parse(this.$store.getters.getCustomerInfo)
                else
                    return this.$store.getters.getCustomerInfo
            },
            customField(){
                return this.$store.getters.getFormCustomFields
            },
            companies(){
                return { out_companies: this.$store.getters.getCompanies}
            },
            
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            pageSettings: function(form){
                this.currentForm = form
            },
            onComplete: function(isLastStep){
                if(isLastStep){
                    this.$router.push('/Customer/List')
                }
            },
            changeStep: async function(prevIndex, nextIndex){
                switch(prevIndex){
                    case 0:
                        return this.$refs.GeneralForm.$refs.Form.validate().then(success =>{
                            if(success){
                                return true
                            }else {
                                this.activeIndex = 0
                                return false
                            }
                        })  
                        break
                     case 1:
                        return this.$refs.DealerForm.$refs.Form.validate().then(success =>{
                            if(success){
                                return true
                            }else {
                                this.activeIndex = 1
                                return false
                            }
                        })  
                        break
                    case 2:
                        return this.$refs.UserForm.$refs.Form.validate().then(async success =>{
                            if(success){
                                let data = {}
                                let rData = []
                                let cf = []
                                rData.push(prepareRequestData(this.GeneralForms, this.$refs.GeneralForm.formData))
                                rData.push(prepareRequestData(this.DealerForm, this.$refs.DealerForm.formData))
                                rData.push(prepareRequestData(this.UserForm, this.$refs.UserForm.formData))
                                _.merge(data, rData[0])
                                _.merge(data, rData[1])
                                _.merge(data, rData[2])
                                this.customField && this.customField.map(custom => {
                                    cf.push({
                                       custom_field_id: custom.id,
                                       value: custom.field_value.Value
                                    })
                                })
                                data.info.custom_fields = cf
                                await this.$store.dispatch('saveCustomer', data)
                                if(this.$store.getters.getCustomerInfo.status == "Success"){
                                    this.activeIndex = 3
                                    await this.$store.dispatch('getCustomerSubscriptions', {customerId: this.$store.getters.getCustomerInfo.data})
                                    return true
                                }else{
                                    this.activeIndex = 2
                                    this.$refs.GeneralForm.formData = setFormData(this.GeneralForms, data)
                                    this.$refs.DealerForm.formData = setFormData(this.DealerForm, data)
                                    this.$refs.UserForm.formData = setFormData(this.UserForm, data)
                                    return false
                                }
                            }else {
                                this.activeIndex = 2
                                return false
                            }
                        })  
                        break
                    case 3:
                        this.activeIndex = 4
                        this.currentForm = "RemoteUser"
                        return true
                    default:
                        this.activeIndex = 0
                        return false
                }
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/Add.vue